import React from 'react';
import styled from 'styled-components';
import { classic } from '~/themes';

type IProps = {
  color: 'primary' | 'secondary';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
  hidden?: boolean;
  type?: 'button' | 'submit' | 'reset';
  ref?: any;
  margin?: string;
  underlined?: boolean;
  textTransform?: string;
};

export default function ButtonText({
  color,
  onClick,
  children,
  disabled,
  hidden,
  type,
  margin,
  ref,
  underlined,
  textTransform,
}: IProps) {
  return (
    <Container
      color={color}
      disabled={disabled}
      hidden={hidden}
      onClick={onClick}
      ref={ref}
      type={type}
      $margin={margin}
      $underlined={underlined}
      $textTransform={textTransform}
    >
      {children}
    </Container>
  );
}

const Container = styled.button<{
  color: 'primary' | 'secondary';
  disabled?: boolean;
  hidden?: boolean;
  $margin?: string;
  $underlined?: boolean;
  $textTransform?: string;
  $uppercase?: boolean;
}>`
  align-items: center;
  border-radius: 16px;
  background-color: transparent;
  border: none;
  color: ${({ color }) => {
    if (color === 'primary') return `${classic.token?.colorText}`;
    if (color === 'secondary') return `${classic.token?.colorFillSecondary}`;

    return `${classic.token?.colorText}`;
  }};

  cursor: pointer;
  display: ${({ hidden }) => (hidden ? 'hidden' : 'flex')};
  flex-direction: row;
  font-family: 'Riffic Free', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  justify-content: center;
  letter-spacing: normal;
  margin: ${({ $margin }) => ($margin ? $margin : '0')};
  opacity: ${({ disabled, hidden }) => {
    if (hidden) return 0;
    if (disabled) return 0.5;

    return 1;
  }};
  padding: 8px 24px;
  pointer-events: ${({ disabled, hidden }) =>
    (disabled ?? hidden) ? 'none' : 'auto'};
  transition: all 0.6s linear;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  outline: none;
  text-decoration: ${({ $underlined }) => ($underlined ? 'underline' : 'none')};
  text-transform: ${({ $textTransform }) =>
    $textTransform ? $textTransform : 'none'};

  @media screen and (max-height: 800px) {
    font-size: 1rem;
    padding: 8px 14px;
  }

  @media screen and (max-width: 450px) {
    font-size: 1rem;
    padding: 8px 14px;
  }
  &:focus {
    color: ${({ color }) => {
      if (color === 'primary') return `${classic.token?.colorPrimaryBgHover}`;
      if (color === 'secondary')
        return `${classic.token?.colorBorderSecondary}`;

      return 'transparent';
    }};
    font-weight: bold;
    outline: none;
  }

  &:hover {
    color: ${({ color }) => {
      if (color === 'primary') return `${classic.token?.colorPrimaryBgHover}`;
      if (color === 'secondary')
        return `${classic.token?.colorBorderSecondary}`;

      return 'transparent';
    }};
  }
`;
